import omnienergy from "../../images/portfolio/Omnienergy.png";
import worthsight from "../../images/portfolio/worthsight.png";
import CIM from "../../images/portfolio/CIM.png";
import Clevermart from "../../images/portfolio/MobileCMView.png";
import Jayhicy from "../../images/portfolio/Jayhicy.png";
import ZITA from "../../images/portfolio/ZITA.png";
import DomuClean from "../../images/portfolio/DomuCLean.png";

export const portfolioList = [
    {
    name: "Domu Clean",
    img: DomuClean,
    link: "https://domuclean.com/",
  },
  {
    name: "Worthsight",
    img: worthsight,
    link: "https://read.cv/fauzeeya/worthsightdocumentation",
  },

  {
    name: "Omni Energy",
    img: omnienergy,
    link: "https://omnienergy.systems/",
  },

  {
    name: "Clever Marketplace",
    img: Clevermart,
    link: "https://clevermart.vercel.app/",
  },

  {
    name: "Jayhicy",
    img: Jayhicy,
    link: "https://jayhicy.vercel.app/",
  },
  {
    name: "Clever Inventory",
    img: CIM,
    link: "https://cleverinventory.vercel.app/",
  },
  {
    name: "ZITA",
    img: ZITA,
    link: "https://zitacademy.netlify.app/",
  },
];
